import React, { useContext } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ComponentManager } from './ComponentManager.js';
import { AppMetaContext } from './appMetaContext.js';
import { PagePathsContext } from './pagePathsContext.js';

const PageManager = ({ pages }) => {
    const appMeta = useContext(AppMetaContext);
    const pagePathsMap = useContext(PagePathsContext);
    if (appMeta === null || pagePathsMap === null) {
        return React.createElement("div", null, "Loading...");
    }
    return (React.createElement(BrowserRouter, null,
        React.createElement(Routes, { key: "routes" },
            Object.values(pagePathsMap).every(path => path !== "/") &&
                React.createElement(Route, { path: "/", key: "root", element: React.createElement(Navigate, { to: pagePathsMap[appMeta.homePage] }) }),
            Object.entries(pagePathsMap).map(([id, path]) => {
                const page = pages.find((page) => page.id === id);
                if (page) {
                    return (React.createElement(Route, { path: path, key: path, element: React.createElement(ComponentManager, { key: page.id, pageId: page.id, pageName: page.name, appName: appMeta.appName, rootComponentId: page.rootComponentId, components: page.components, events: page.events }) }));
                }
            }))));
};

export { PageManager };
//# sourceMappingURL=PageManager.js.map
